import { useNavigate } from "react-router-dom";
import { Button } from "@/shared/components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-main-dark px-6 text-center text-white">
      <h1 className="text-2xl font-medium">Payment canceled</h1>
      <p className="max-w-sm text-sm text-white/70">
        Your payment was not completed. You can go back and choose your
        membership again whenever you are ready.
      </p>
      <div className="flex flex-wrap justify-center gap-3">
        <Button onClick={() => navigate("/plan/membership", { replace: true })}>
          Return to Membership
        </Button>
        <Button
          variant="outline"
          className="border-white/30 text-white"
          onClick={() => navigate("/dashboard", { replace: true })}>
          Go to Dashboard
        </Button>
      </div>
    </div>
  );
}
